/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useEffect } from "react";

export default function QontoOAuthReturn() {
  useEffect(() => {
    window.opener?.postMessage(
      {
        type: "QONTO_OAUTH_DONE",
        success: true,
      },
      window.location.origin
    );

    window.close();
  }, []);

  return null;
}
